import buildBooleanFilter from '../buildBooleanFilter'

const NewSellerFilter = buildBooleanFilter({
  key: 'newSeller',
  filterTitle: 'new_seller',
})

export default NewSellerFilter
